import React from 'react';
import { ScrollView, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import { AppText } from '@/components/ui/AppText';
import { BackHeader } from '@/components/ui/BackHeader';
import { Card } from '@/components/ui/Card';
import { Screen } from '@/components/ui/Screen';

const CONTACT = 'mohamedmavis79@gmail.com';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <View className="gap-1.5">
      <AppText variant="heading">{title}</AppText>
      {children}
    </View>
  );
}

function P({ children }: { children: React.ReactNode }) {
  return (
    <AppText variant="caption" className="leading-6 text-soft">
      {children}
    </AppText>
  );
}

/**
 * Public privacy policy - also served on the web build at /privacy so it can be
 * used as the Google Play "privacy policy URL". Mirrors docs/PRIVACY.md.
 */
export default function PrivacyScreen() {
  const { t } = useTranslation();
  return (
    <Screen watermark={false}>
      <BackHeader title={t('privacy.title')} />
      <ScrollView contentContainerStyle={{ padding: 20, paddingBottom: 48, gap: 18 }}>
        <Card className="gap-1 px-4 py-4">
          <AppText variant="title">Tashkeela</AppText>
          <AppText variant="micro" className="text-muted">
            {t('privacy.updated')}
          </AppText>
        </Card>

        <Section title={t('privacy.collectTitle')}>
          <P>{t('privacy.collectBody')}</P>
        </Section>

        <Section title={t('privacy.useTitle')}>
          <P>{t('privacy.useBody')}</P>
        </Section>

        <Section title={t('privacy.providersTitle')}>
          <P>{t('privacy.providersBody')}</P>
        </Section>

        <Section title={t('privacy.securityTitle')}>
          <P>{t('privacy.securityBody')}</P>
        </Section>

        <Section title={t('privacy.deletionTitle')}>
          <P>{t('privacy.deletionBody')}</P>
        </Section>

        <Section title={t('privacy.childrenTitle')}>
          <P>{t('privacy.childrenBody')}</P>
        </Section>

        <Section title={t('privacy.contactTitle')}>
          <P>
            {t('privacy.contactBody')} {CONTACT}
          </P>
        </Section>
      </ScrollView>
    </Screen>
  );
}
